/**
 * Mock data for Home & Explore screens
 * 
 * This file contains temporary curated content until the backend API is ready.
 * TODO(api): Replace with HomeExploreContentService once backend is deployed
 */

export interface GuruRecommendation {
  id: string;
  name: string;
  imageUrl: any; // require() asset
  title: string;
  subtitle: string;
  bookCount: number;
  insightCount: number;
  bookIds: string[]; // Real Firestore book IDs
  source: 'mock' | 'featured' | 'popular';
}

export interface CuratedCollection {
  id: string;
  title: string;
  subtitle: string;
  description?: string;
  bookIds: string[];
  source: 'mock' | 'featured' | 'popular';
}

/**
 * Guru recommendations with their curated book lists
 * Using existing guru assets from onboarding
 */
export const GURU_RECOMMENDATIONS: GuruRecommendation[] = [
  {
    id: 'elon-musk',
    name: 'Elon Musk',
    imageUrl: require('../../assets/onboarding/gurus/elon_musk.jpg'),
    title: 'Elon Musk Recommends',
    subtitle: 'Innovation and first principles thinking',
    bookCount: 6,
    insightCount: 143,
    bookIds: ['17', '16', '19', '24', '26', '22'], // The Lean Startup, Zero to One, Hard Thing, Hooked, Crossing Chasm, Innovator's Dilemma
    source: 'mock',
  },
  {
    id: 'bill-gates',
    name: 'Bill Gates',
    imageUrl: require('../../assets/onboarding/gurus/bill_gates.jpg'),
    title: 'Bill Gates Recommends',
    subtitle: 'Technology, science, and global progress',
    bookCount: 8,
    insightCount: 187,
    bookIds: ['71', '52', '49', '51', '66', '36'], // Why We Sleep, Think Again, Freakonomics, Guns Germs Steel, Good to Great, Psychology of Money
    source: 'mock',
  },
  {
    id: 'oprah-winfrey',
    name: 'Oprah Winfrey',
    imageUrl: require('../../assets/onboarding/gurus/oprah_winfrey.jpg'),
    title: 'Oprah Recommends',
    subtitle: 'Personal growth and transformation',
    bookCount: 7,
    insightCount: 156,
    bookIds: ['40', '72', '73', '70', '75', '13'], // Power of Now, New Earth, Gifts of Imperfection, Daring Greatly, Untethered Soul, Four Agreements
    source: 'mock',
  },
  {
    id: 'tony-robbins',
    name: 'Tony Robbins',
    imageUrl: require('../../assets/onboarding/gurus/tony_robbins.jpg'),
    title: 'Tony Robbins Recommends',
    subtitle: 'Peak performance and life mastery',
    bookCount: 6,
    insightCount: 134,
    bookIds: ['7', '77', '15', '60', '82', '65'], // 7 Habits, Think and Grow Rich, Man's Search, Influence, Mindset, Can't Hurt Me
    source: 'mock',
  },
  {
    id: 'warren-buffett',
    name: 'Warren Buffett',
    imageUrl: require('../../assets/onboarding/gurus/warren_buffett.jpg'),
    title: 'Warren Buffett Recommends',
    subtitle: 'Investing wisdom and business strategy',
    bookCount: 5,
    insightCount: 98,
    bookIds: ['80', '36', '81', '79', '87'], // Intelligent Investor, Psychology of Money, Millionaire Next Door, Richest Man Babylon, Black Swan
    source: 'mock',
  },
  {
    id: 'michelle-obama',
    name: 'Michelle Obama',
    imageUrl: require('../../assets/onboarding/gurus/michelle_obama.jpg'),
    title: 'Michelle Obama Recommends',
    subtitle: 'Leadership, family, and social impact',
    bookCount: 6,
    insightCount: 121,
    bookIds: ['83', '70', '52', '43', '96', '99'], // Grit, Daring Greatly, Think Again, Untamed, Attached, Whole-Brain Child
    source: 'mock',
  },
];

/**
 * Curated collections for the Collections section
 */
export const CURATED_COLLECTIONS: CuratedCollection[] = [
  {
    id: 'launch-your-big-idea',
    title: 'Launch Your Big Idea',
    subtitle: 'From concept to successful startup',
    description: 'Essential reads for entrepreneurs and innovators',
    bookIds: ['17', '16', '19', '18'], // Lean Startup, Zero to One, Hard Thing, Rework
    source: 'mock',
  },
  {
    id: 'master-your-mind',
    title: 'Master Your Mind',
    subtitle: 'Psychology and mental performance',
    description: 'Understand how your mind works',
    bookIds: ['9', '1', '10', '82'], // Thinking Fast and Slow, Atomic Habits, Power of Habit, Mindset
    source: 'mock',
  },
  {
    id: 'build-better-habits',
    title: 'Build Better Habits',
    subtitle: 'Transform your daily routines',
    description: 'Science-backed strategies for lasting change',
    bookIds: ['1', '10', '4', '7'], // Atomic Habits, Power of Habit, High Performance Habits, 7 Habits
    source: 'mock',
  },
  {
    id: 'find-your-focus',
    title: 'Find Your Focus',
    subtitle: 'Deep work and concentration',
    description: 'Cut through distractions and do meaningful work',
    bookIds: ['46', '53', '5', '1'], // Four Thousand Weeks, Dopamine Nation, Subtle Art, Atomic Habits
    source: 'mock',
  },
];

/**
 * Heavy-hitting classics section
 * These are timeless books that have shaped millions of lives
 */
export const HEAVY_HITTERS: CuratedCollection = {
  id: 'heavy-hitters',
  title: 'Heavy-Hitting Books',
  subtitle: 'Timeless classics that shaped millions of lives',
  bookIds: ['1', '9', '7', '15', '40', '60', '77', '6'], // Atomic Habits, Thinking Fast Slow, 7 Habits, Man's Search, Power of Now, Influence, Think and Grow Rich, Win Friends
  source: 'mock',
};

/**
 * Latest summaries section
 * Newest additions to the library
 */
export const LATEST_SUMMARIES: CuratedCollection = {
  id: 'latest-summaries',
  title: 'Latest Summaries',
  subtitle: 'Fresh insights from newly added books',
  bookIds: [], // Will be populated from BookService.getNewBooks()
  source: 'featured',
};

/**
 * Popular now section
 * Trending books based on user engagement
 */
export const POPULAR_NOW: CuratedCollection = {
  id: 'popular-now',
  title: 'Popular Now',
  subtitle: "See what's trending in the community",
  bookIds: [], // Will be populated from BookService.getPopularBooks()
  source: 'popular',
};

